"use client";

import type { PhoneClickPlacement } from "./types/phone-click-placement";

import { EventName } from "@homeinstead/shared";
import { track } from "./analytics";

type TrackPhoneClickArgs = {
  /**
   * Optional placement context surfaced on the analytics payload as
   * `placement`.
   */
  placement?: PhoneClickPlacement;
};

/**
 * Track a phone-number click.
 */
const trackPhoneClick = ({ placement }: TrackPhoneClickArgs = {}) => {
  track(EventName.PHONE_NUMBER_CLICK, {
    event: EventName.PHONE_NUMBER_CLICK,
    lang: "en",
    page_url: typeof window !== "undefined" ? window.location.href : undefined,
    ...(placement ? { placement } : {}),
  });
};

export { trackPhoneClick };
